import React, { useMemo } from 'react'
import { clampScore, formatScore, SCORE_MAX, scoreColor } from './scoreUtils'
import { normalizeQuestStatus } from './questTypes'

function evaluatedPoints(nodes) {
  const points = []
  ;(nodes || []).forEach((node, index) => {
    const item = node.item
    const status = normalizeQuestStatus(
      item?.progress?.status,
      item?.assignmentStatus || item?.progress?.assignmentStatus,
    )
    const score = status === 'evaluated' ? clampScore(item?.evaluationSummary?.score) : null
    if (score == null) return
    points.push({ index, score, title: item?.title || '关卡' })
  })
  return points
}

/** 地图顶部的得分折线，点击进入成长评价报告 */
export default function QuestGrowthBar({ nodes, onOpen, badgeText = '', stageText = '' }) {
  const points = useMemo(() => evaluatedPoints(nodes), [nodes])
  if (points.length < 1) return null

  const width = 168
  const height = 36
  const pad = 4
  const coords = points.map((point, order) => {
    const x = points.length === 1
      ? width / 2
      : pad + (order / (points.length - 1)) * (width - pad * 2)
    const y = height - pad - (point.score / SCORE_MAX) * (height - pad * 2)
    return { ...point, x, y }
  })
  const poly = coords.map((point) => `${point.x},${point.y}`).join(' ')
  const last = coords[coords.length - 1]
  const label = `已评价 ${points.length} 关，最近 ${formatScore(last.score)} 分`

  const body = (
    <>
      <span className="quest-growth-copy">
        <span className="quest-growth-kicker">成长轨迹</span>
        <span className="quest-growth-label">{label}</span>
        {stageText || badgeText ? (
          <span className="quest-growth-meta">{[stageText, badgeText].filter(Boolean).join(' · ')}</span>
        ) : null}
      </span>
      <svg className="quest-growth-line" viewBox={`0 0 ${width} ${height}`} aria-hidden="true">
        {coords.length > 1 ? (
          <polyline
            points={poly}
            fill="none"
            stroke={scoreColor(last.score)}
            strokeWidth="2.5"
            strokeLinejoin="round"
            strokeLinecap="round"
          />
        ) : null}
        {coords.map((point) => (
          <circle key={point.index} cx={point.x} cy={point.y} r="2.4" fill={scoreColor(point.score)} />
        ))}
      </svg>
    </>
  )

  if (!onOpen) {
    return <div className="quest-growth-bar">{body}</div>
  }

  return (
    <button type="button" className="quest-growth-bar" onClick={() => onOpen?.()} aria-label="查看成长评价报告">
      {body}
    </button>
  )
}
